export default __webpack_public_path__ + "static/media/1314.c2cd5d96.png";